import {useExecuteApi} from "@/composables/api/useExecuteApi";
import {createGetAdminProfilesRequest} from "@/services/requests/agentRequests.js";

export function useAgentApi() {
  const {executeApi} = useExecuteApi();

  const getAdminProfiles = () => executeApi({
    requestFactory: createGetAdminProfilesRequest,
    dataPath: "data.profiles",
    requireData: false,
    message: {
      success: "agents.api.loadSuccess",
      error: "agents.api.loadError",
    },
  });

  return {getAdminProfiles};
}
